import { ITrackerConfigModel, TrackersEnum } from "../models/TrackerModel";

export const trackerConfigurations: ITrackerConfigModel[] = [
  {
    type: TrackersEnum.DEFAULT,
    title: 'Default',

    displayCount: true,
    searchLead: true,
    filterLead: true,
    swicthDisplay: true,

    displayProduct: true,
    createLead: true,
    // displaySecondHeader: true,
    // displaySlider: true,
    displayViewSort: false,
  },
  {
    type: TrackersEnum.PROSPECTING,
    title: 'Prospects',
    displayCount: true,
    searchLead: true,
    filterLead: true,
    swicthDisplay: true,
    createLead: true,
  },
  {
    type: TrackersEnum.APPLICATIONS,
    title: 'Applications',
    displayCount: true,
    searchLead: true,
    filterLead: true,
    swicthDisplay: true,
    displayProduct: true,
  },
  {
    type: TrackersEnum.OPPORTUNITIES,
    title: 'Opportunities',
    displayCount: true,
    searchLead: true,
    filterLead: true,
    swicthDisplay: true,
    displayProduct: true,
  },
  {
    type: TrackersEnum.UNDERWRITING,
    title: 'Underwriting',
    displayCount: true,
    searchLead: true,
    filterLead: true,
    swicthDisplay: true,
    displayProduct: true,
  },
  {
    type: TrackersEnum.RELATIONSHIPS,
    title: 'Relationships',
    displayCount: true,
    searchLead: true,
    filterLead: true,
    swicthDisplay: true,
    displayViewSort: false,
  }
]